import { useUnit } from 'effector-react';
import { $profileFeatureStore } from '@lib/store/profile';
import { cn } from '@shared/utils';
import { UserType, type AccountResponse, type CardResponse } from '@shared/api';
import { UserLongInfoItem } from './userLongInfoItem';
import { Icon } from '@shared/widgets';
import AccountIcon from '@assets/icons/account.svg';
import CardIcon from '@assets/icons/card.svg';

interface UserLongInfoProps {
  type: UserType;
  locked: boolean;
  open: boolean;
  userId: string;
  accounts: AccountResponse[];
  cards: CardResponse[];
  openAddCard: () => void;
  openAddAccount: () => void;
  removeAccount: (id: number) => void;
  removeCard: (id: number) => void;
}

export const UserLongInfo = (props: UserLongInfoProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  if (props.type === UserType.Admin || !profileFeatureStore.data?.userManagement.managerAccountsOrCardsPermissions) return null;
  return (
    <div className={cn(props.locked && 'pointer-events-none select-none opacity-50')}>
      {props.type === UserType.Manager && (
        <UserLongInfoItem
          show={props.open}
          type={UserType.Manager}
          userId={props.userId}
          accounts={props.accounts}
          removeItem={props.removeAccount}
          icon={<Icon icon={<AccountIcon />} color='secondary-inverse' />}
          showAddModal={props.openAddAccount}
        />
      )}
      {props.type === UserType.User && (
        <UserLongInfoItem
          show={props.open}
          type={UserType.User}
          userId={props.userId}
          cards={props.cards}
          removeItem={props.removeCard}
          icon={<Icon icon={<CardIcon />} color='secondary-inverse' />}
          showAddModal={props.openAddCard}
        />
      )}
    </div>
  );
};
